import { ITag } from "@edgetier/watchtower-types";
import { IInteractionTagGroup } from "./interaction-tags.types";

/**
 * Find which tagIds should be passed to DELETE and POST requests when a tag groups is updated
 * @param tagGroup
 * @param tagIds
 * @param interactionTags
 * @returns Tag ids for DELETE and POST request and the pther tags with a different tag group
 */
export const formatTagIdsForUpdateTagGroup = (tagGroup: string, tagIds: string[], interactionTags: ITag[]) => {
    // Find removed tags from initial interaction tags
    const deleteTagIds = interactionTags
        .filter((tag) => tag.tagGroup === tagGroup && !tagIds.includes(tag.tagId))
        .map(({ tagId }) => ({ tagId }));

    // Tags with different tag group
    const differentTagGroupTags = interactionTags.filter((tag) => tag.tagGroup !== tagGroup);

    const existingTagIds = interactionTags.map(({ tagId }) => tagId);

    // Tag ids added after any changes to a tag group
    const postTagIds = tagIds.filter((tagId) => !existingTagIds.includes(tagId)).map((tagId) => ({ tagId }));

    return {
        deleteTagIds,
        postTagIds,
        differentTagGroupTags,
    };
};

/**
 * Find which tagIds should be passed to DELETE request when a tag group is removed
 * @param tagGroup
 * @param interactionTags
 * @returns Tag ids for DELETE request and the pther tags with a different tag group
 */
export const formatTagIdsForRemoveTagGroup = (tagGroup: string, interactionTags: ITag[]) => {
    // Collect all interaction tag ids from tag group
    const deleteTagIds = interactionTags.filter((tag) => tag.tagGroup === tagGroup).map(({ tagId }) => ({ tagId }));

    // Tags with different tag group
    const differentTagGroupTags = interactionTags.filter((tag) => tag.tagGroup !== tagGroup);

    return {
        deleteTagIds,
        differentTagGroupTags,
    };
};

/**
 * Update the interaction tag groups in a specific order. Any new tag groups should be displayed
 * above all existing tag group
 * @param interactionTagGroups Interaction tag groups
 * @param newTagGroupsIdsOrder New tag group ids in the created order
 */
export const reorderInteractionTagGroups = (
    interactionTagGroups: IInteractionTagGroup,
    newTagGroupsIdsOrder: string[]
) => {
    // Tag groups that were added to interaction and didn't existed
    const newTagGroups = Object.keys(interactionTagGroups)
        .filter((key) => newTagGroupsIdsOrder.includes(key))
        .reduce((res, key) => ({ ...res, [key]: interactionTagGroups[key] }), {});

    // Tag groups that existed in interaction group
    const existingTagGroups = Object.keys(interactionTagGroups)
        .filter((key) => !newTagGroupsIdsOrder.includes(key))
        .reduce((res, key) => ({ ...res, [key]: interactionTagGroups[key] }), {});

    return { ...newTagGroups, ...existingTagGroups };
};
